export default "__VITE_ASSET__DJEc3Eaz__"